import React from 'react';
import './AboutBanner.css';
import AboutBannerImage from '../images/AboutBanner.jpg';

const AboutBanner = () => {
  return (
    <section className="about-banner">
      <div className="about-banner-container">
        <div className="about-banner-left">
          <div className="about-banner-image" style={{ backgroundImage: `url(${AboutBannerImage})` }}>
            <div className="about-image-overlay">
              <h1 className="about-banner-title">ABOUT US</h1>
            </div>
          </div>
        </div>
        <div className="about-banner-right">
          <div className="about-banner-content">
            <h2 className="about-banner-subtitle">WE ARE YOUR<br />EXCLUSIVE ASSISTANT</h2>
            <p className="about-banner-description">
              Ampire Finance is your trusted partner for your personalized financial requirements.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBanner;
